<template>
	<el-dialog
		width="800px"
		:close-on-click-modal="false"
		title="录入维修信息"
		:visible.sync="dialogFormVisible"
		v-loading="loading"
	>
		<el-form :model="form" ref="form" :rules="rules" v-loading="loading">
			<el-row :gutter="20">
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修供应商：" prop="vrepairHallName">
						<el-input v-model="form.vrepairHallName"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修供应商联系人：" prop="vrepairHallContact">
						<el-input v-model="form.vrepairHallContact"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修供应商电话：" prop="vrepairHallTelephone">
						<el-input v-model="form.vrepairHallTelephone"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修供应商地址：" prop="vrepairHallAddress">
						<el-input v-model="form.vrepairHallAddress"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修人员姓名：" prop="vrepairManName">
						<el-input v-model="form.vrepairManName"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修人员电话：" prop="vrepairManTelephone">
						<el-input v-model="form.vrepairManTelephone"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :xs="24">
					<el-form-item label="维修人员工号：" prop="vrepairManJobNo">
						<el-input v-model="form.vrepairManJobNo"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="24" :xs="24">
					<el-form-item label="维修备注：">
						<el-input type="textarea" v-model="form.vremark"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button v-loading="loading" type="primary" @click="confirm"
				>确 定</el-button
			>
		</div>
	</el-dialog>
</template>
<script>
export default {
	name: "serviceDialog",
	data() {
		var isPhone = (rule, value, callback) => {
			if (!value) {
				return callback();
			}
			if (this.$utils.isPhone(value)) {
				callback();
			} else {
				return callback(new Error("手机号格式错误"));
			}
		};
		return {
			loading: false,
			dialogFormVisible: false,
			fkFacilityRepairOrderId: "",
			form: {
				vrepairHallName: "", // 维修服务商名称
				vrepairHallAddress: "", // 维修服务商地址
				vrepairHallTelephone: "", // 维修服务商电话
				vrepairHallContact: "", // 维修服务商联系人
				vrepairManName: "", // 维修人员姓名
				vrepairManTelephone: "", // 维修人员电话
				vrepairManJobNo: "", // 维修人员工号
				vremark: "", // 备注
			},
			formLabelWidth: "120px",
			rules: {
				vrepairHallName: [
					{
						required: true,
						message: "请输入维修供应商",
						trigger: ["blur", "change"],
					},
				],
				vrepairHallAddress: [
					{
						required: true,
						message: "请输入维修供应商地址",
						trigger: ["blur", "change"],
					},
				],
				vrepairHallTelephone: [
					{
						required: true,
						message: "请输入维修供应商电话",
						trigger: ["blur", "change"],
					},
					{ max: 32, message: "请输入正确的电话", trigger: "blur" },
					// { validator: isPhone, trigger: "blur" },
				],
				vrepairHallContact: [
					{
						required: true,
						message: "请输入维修供应商联系人",
						trigger: ["blur", "change"],
					},
				],
				vrepairManName: [
					{
						required: true,
						message: "请输入维修人员姓名",
						trigger: ["blur", "change"],
					},
				],
				vrepairManTelephone: [
					{
						required: true,
						message: "请输入维修人员电话",
						trigger: ["blur", "change"],
					},
					{ max: 32, message: "请输入正确的电话", trigger: "blur" },
					// { validator: isPhone, trigger: "blur" },
				],
				vrepairManJobNo: [
					{
						required: true,
						message: "请输入维修人员工号",
						trigger: ["blur", "change"],
					},
				],
			},
		};
	},

	methods: {
		initData(id) {
			this.fkFacilityRepairOrderId = id;
		},
		cancel() {
			this.$refs.form.resetFields();
			this.dialogFormVisible = false;
		},
		confirm() {
			const vm = this;
			this.loading = true;
			this.$refs.form.validate((valid) => {
				if (valid) {
					var postData = {
						fkFacilityRepairOrderId: vm.fkFacilityRepairOrderId,
						...vm.form,
					};
					this.$http
						.post("/facilityRepairOrder/addRepairOrderExtend", postData)
						.then(function (response) {
							vm.loading = false;
							if (response.data.header.code == "A1000") {
								vm.cancel();
								vm.$message.success(response.data.header.msg);
								vm.$emit("change");
							} else {
								vm.$message.warning(response.data.header.msg);
							}
						})
						.catch(function (error) {
							console.log(1, error);
							vm.loading = false;
							vm.$message.error("网络错误");
						});
				} else {
					vm.loading = false;
				}
			});
		},
	},
};
</script>
